import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ImagePage from 'pages/Test/Image';

const TestRoutes = () => (
  <Routes>
    <Route path="/image" element={<ImagePage />}></Route>
  </Routes>
);

export default TestRoutes;
